import './styles.scss'

import logoGovCeara from 'assets/logos/logo-gov-ce.svg'
import logoGovCearaWhite from 'assets/logos/logo-gov-ce-white.svg'
import facebookImg from 'assets/logos/facebook.svg'
import instagramImg from 'assets/logos/instagram.svg'
import twitterImg from 'assets/logos/twitter.svg'
import youtubeImg from 'assets/logos/youtube.svg'
import { useAccessibility } from 'context/hooks/useAccessibility'

const Footer = () => {
  const { contrastIsSelected } = useAccessibility()

  return (
    <footer className="footerContainer">
      <div className="footerContainer-line">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <section className="footerContainer-content">
        <div className="footerContainer-content__logos">
          <img
            src={contrastIsSelected ? logoGovCearaWhite : logoGovCeara}
            alt="Logo do Governo do Ceará em branco"
          />
        </div>

        <ul className="footerContainer-content__menu">
          <li>
            <a href={`${
                process.env.REACT_APP_BIGDATA_URL ?? ''
              }/info/mapa-site`}>Mapa do site</a>
          </li>
          <li>
            <a href={`${
                process.env.REACT_APP_BIGDATA_URL ?? ''
              }/info/aviso-privacidade`}>
              Aviso de privacidade
            </a>
          </li>

          <li>
            <a href={`${
                process.env.REACT_APP_BIGDATA_URL ?? ''
              }/info/termos`}>
              Termos de uso
            </a>
          </li>
        </ul>

        <div className="footerContainer-content__contact">
          <ul className="contact-redes">
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/governodoceara"
              >
                <img src={facebookImg} alt="logo facebook" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/governodoceara/"
              >
                <img src={instagramImg} alt="logo instagram" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/GovernoDoCeara"
              >
                <img src={twitterImg} alt="logo twitter" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/channel/UCkpDYTqJkGp66nHngzZVzAw"
              >
                <img src={youtubeImg} alt="logo youtube" />
              </a>
            </li>
          </ul>
          <strong>
            Central de atendimento - <b>155</b>
          </strong>
          <strong>
            Acessibilidade - <b>0800 275 0022</b>
          </strong>
        </div>
      </section>
      <section className="footerContainer-copyright">
        <strong>
          &copy; Governo do Estado do Ceará. Todos os direitos reservados.
        </strong>
      </section>
    </footer>
  )
}

export default Footer
